module.exports = __webpack_public_path__ + "static/media/soccer-1.99b5fe33.svg";